var render = function render(){var _vm=this,_c=_vm._self._c;return _c('add-user',{on:{"createUser":function($event){return _vm.createUser($event)},"editUser":function($event){return _vm.editUser($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }